// Debug utility to check events in Firebase
import { getEvents } from '../services/firestoreService';

export const debugEventsInFirebase = async () => {
  try {
    console.log('🔍 Debugging events in Firebase...');
    
    // Get all events
    const allEvents = await getEvents(50, false);
    console.log('📊 Total events found:', allEvents.length);
    
    if (allEvents.length > 0) {
      console.log('📋 Event structure analysis:');
      allEvents.forEach((event, index) => {
        console.log(`\n--- Event ${index + 1} ---`);
        console.log('ID:', event.id);
        console.log('Title:', event.title);
        console.log('Has imageUrl:', !!event.imageUrl);
        console.log('Has image:', !!event.image);
        console.log('imageUrl value:', event.imageUrl);
        console.log('image value:', event.image);
        console.log('All fields:', Object.keys(event));
        console.log('Start Date:', event.startDate);
        console.log('Location:', event.location);
      });
    } else {
      console.log('❌ No events found in Firebase');
    }
    
    // Get upcoming events specifically
    const upcomingEvents = await getEvents(20, true);
    console.log('\n🔮 Upcoming events found:', upcomingEvents.length);
    
    if (upcomingEvents.length > 0) {
      console.log('📋 Upcoming events details:');
      upcomingEvents.forEach((event, index) => {
        console.log(`\n--- Upcoming Event ${index + 1} ---`);
        console.log('ID:', event.id);
        console.log('Title:', event.title);
        console.log('Start Date:', event.startDate);
        console.log('Image URL:', event.imageUrl);
        console.log('Image field:', event.image);
      });
    }
    
    return { allEvents, upcomingEvents };
  } catch (error) {
    console.error('❌ Error debugging events:', error);
    return { allEvents: [], upcomingEvents: [] };
  }
};

// Function to update events with default images if they don't have any
export const updateEventsWithDefaultImages = async () => {
  try {
    console.log('🔧 Updating events with default images...');
    
    const { updateEvent } = await import('../services/firestoreService');
    const allEvents = await getEvents(50, false);
    
    let updatedCount = 0;
    
    for (const event of allEvents) {
      if (!event.imageUrl && !event.image) {
        console.log(`📝 Updating event "${event.title}" with default image...`);
        
        await updateEvent(event.id, {
          imageUrl: '/apn-logos/APN-blue (1).png'
        });
        
        updatedCount++;
      }
    }
    
    console.log(`✅ Updated ${updatedCount} events with default images`);
    return updatedCount;
  } catch (error) {
    console.error('❌ Error updating events:', error);
    return 0;
  }
};

// Export for use in console
window.debugEventsInFirebase = debugEventsInFirebase;
window.updateEventsWithDefaultImages = updateEventsWithDefaultImages;
